// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YzpA","select":"styles_select__1A_E7"};